import { render, staticRenderFns } from "./TreeItem2.vue?vue&type=template&id=f1357442"
import script from "./TreeItem2.vue?vue&type=script&lang=js"
export * from "./TreeItem2.vue?vue&type=script&lang=js"
import style0 from "./TreeItem2.vue?vue&type=style&index=0&id=f1357442&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports